import React, { useEffect } from "react";
import img1 from "../../../assets/gps/specialFeature1.png";
import img2 from "../../../assets/gps/specialFeature2.png";
import img3 from "../../../assets/gps/specialFeature3.png";
import AOS from "aos";
import "aos/dist/aos.css";
const SpecialFeature = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 100,
      delay: 200,
    });
  }, []);
  return (
    <div className="mx-8 lg:mx-12 ">
      <div className="grid grid-cols-3 gap-5" data-aos="fade-left">
        <img src={img1} alt="specialImage1" />
        <img src={img2} alt="specialImage2" />
        <img src={img3} alt="specialImage3" />
      </div>
    </div>
  );
};

export default SpecialFeature;
